<template>
  <div class="person-message">
    <div class="wrapper">
      <base-title :title="`消息推送`"></base-title>
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="推送时间：">
          <el-date-picker
            v-model="form.date"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择推送时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="发送人：">
          <el-input v-model="form.name" placeholder="请输入发送人昵称"></el-input>
        </el-form-item>
        <el-form-item label="回复内容：">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 8}"
            v-model="form.message"
            placeholder="请输入消息内容"
          ></el-input>
        </el-form-item>
        <el-form-item label="链接名称：">
          <el-input v-model="form.link_name" placeholder="如：点我抢福利"></el-input>
        </el-form-item>
        <el-form-item label="跳转链接：">
          <el-form-item label="内部链接" label-width="80px">
            <el-cascader
              :options="options"
              @change="handleChange"
              :props="{ expandTrigger: 'hover' }"
              v-model="form.interior_link"
              clearable
            ></el-cascader>
            </el-form-item>
            <el-form-item label="外部链接" label-width="80px" class="mt20">
              <el-input v-model="form. outside_link" placeholder="请输入正确的链接地址"></el-input>
          </el-form-item>
        </el-form-item>
        <el-form-item label>
          <el-button type="primary" @click="send()">发送</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>


<script>
import Title from "@/views/course/play-template/title.vue";

export default {
  created() {},
  components: {
    "base-title": Title
  },
  data() {
    return {
      options: [
        {
          value: "live",
          label: "直播",
          children: [
            {
              value: "sheji",
              label: "设计原则",
              children: [
                {
                  value: "shiji1",
                  label: "设计一"
                },
                {
                  value: "fankui",
                  label: "设计二"
                },
                {
                  value: "xiaolv",
                  label: "设计三"
                },
                {
                  value: "kekong",
                  label: "设计四"
                }
              ]
            },
            {
              value: "daohang",
              label: "导航",
              children: [
                {
                  value: "cexiangdaohang",
                  label: "侧向导航"
                },
                {
                  value: "dingbudaohang",
                  label: "顶部导航"
                }
              ]
            }
          ]
        }
      ],
      form: {
        date: "",
        name: "",
        message: "",
        link_name: "",
        interior_link:[],
        outside_link:'',
      }
    };
  },
  methods: {
    send() {
      console.log("发送全员信息");
    },
    handleChange(val) {
      console.log(val);
    }
  }
};
</script>


<style lang="less" scoped>
.person-message {
  padding: 20px;
  min-height: 1000px;
  background: #ffffff;
  .wrapper {
    max-width: 800px;
  }
}
</style>
